export { type GraphemePrcData, graphemePrcDataTable } from "#grapheme-prc-data-table";
